const mail = {
    svg: '<svg style="width:1.00rem; height:1.00rem;" viewBox="0 0 16 16"><polygon points="16 11.1538462 16 0.846153846 10.5185185 6"/><polygon points="8.03703704 8.31761226 6.46592744 6.84615385 0.962962963 12 15.1111111 12 9.60814663 6.84615385"/><polygon points="15.1111111 0 0.962962963 0 8.03703704 6.61538462"/><polygon points="0 0.846153846 0 11.1538462 5.48148148 6"/></svg>',
};

export { mail as default };
